import axios from '../config/axios';

class UnitsManagementService {

  async getUnits(condoId) {
    try {
      const response = await axios.get(`/v3/admin/units-management/${condoId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar unidades:', error);
      throw error;
    }
  }


  async getUnitDetails(unitId) {
    try {
      const response = await axios.get(`/v3/admin/units-management/unit/${unitId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar detalhes da unidade:', error);
      throw error;
    }
  }

  async updateUnitConfig(unitId, config) {
    if (!unitId || unitId === null || unitId === "null") {
      throw new Error('ID da unidade é obrigatório');
    }
    
    const directUrl = `/v3/admin/units-management/unit/${unitId}`;
    
    try {
      const response = await axios.patch(directUrl, config);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar configurações da unidade:', error);
      throw error;
    }
  }

  async enableBigDataCorp(unitId) {
    const defaultConfig = {
      enabled: true,
      alertSettings: {
        enabled: true,
        adminEmail: '',
        unitEmail: '',
        whatsappEnabled: false,
        whatsappSender: '',
        whatsappRecipients: [],
        alertTypes: {
          arrest_warrant: true,
          sanctions: true,
          pep: false,
          criminal_history: false
        }
      }
    };

    return this.updateUnitConfig(unitId, defaultConfig);
  }

  async disableBigDataCorp(unitId) {
    return this.updateUnitConfig(unitId, { enabled: false });
  }

  async updateAlertSettings(unitId, alertSettings) {
    return this.updateUnitConfig(unitId, { alertSettings });
  }
}

export default new UnitsManagementService();